// Hook for managing appointment confirmation dialog triggered by notifications
import { create } from 'zustand';

interface AppointmentConfirmationState {
  isOpen: boolean;
  appointmentId: string | null;
  appointmentDetails: {
    clientName?: string;
    serviceName?: string;
    startTime?: string;
    endTime?: string;
    staffNames?: string[];
  };
  notificationId?: string | null; // Add notificationId
  openDialog: (appointmentId: string, details: any, notificationId?: string) => void;
  closeDialog: () => void;
}

export const useAppointmentConfirmationStore = create<AppointmentConfirmationState>((set) => ({
  isOpen: false,
  appointmentId: null,
  appointmentDetails: {},
  notificationId: null, // Initialize notificationId
  openDialog: (appointmentId, details, notificationId) =>
    set({
      isOpen: true,
      appointmentId,
      appointmentDetails: {
        clientName: details.clientName,
        serviceName: details.serviceName,
        startTime: details.startTime,
        endTime: details.endTime,
        staffNames: details.staffNames,
      },
      notificationId, // Store notificationId
    }),
  closeDialog: () =>
    set({
      isOpen: false,
      appointmentId: null,
      appointmentDetails: {},
      notificationId: null, // Clear notificationId
    }),
}));
